// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModeSelect_mode__fFifM {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ModeSelect_mode--title__Vfzou {
  color: var(--dark-grey);
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/ModeSelect/ModeSelect.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;AACE;EACE,uBAAA;EACA,gBAAA;AACJ","sourcesContent":[".mode {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  &--title {\n    color: var(--dark-grey);\n    font-weight: 600;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mode": `ModeSelect_mode__fFifM`,
	"mode--title": `ModeSelect_mode--title__Vfzou`
};
export default ___CSS_LOADER_EXPORT___;
